import { Box, Checkbox, Chip, FormControlLabel, Typography } from '@material-ui/core'

import { StoreSelectionRow } from '../../domain/storeEligibility'
import { BulkGoalClasses } from '../../types'

interface StoreSelectionCardProps {
  classes: BulkGoalClasses
  disabled: boolean
  hasLeftStep0: boolean
  row: StoreSelectionRow
  selectedStoreIds: Set<string>
  toggleStore: (storeId: string) => void
}

const StoreSelectionCard = ({
  classes,
  disabled: forceDisabled,
  hasLeftStep0,
  row,
  selectedStoreIds,
  toggleStore
}: StoreSelectionCardProps) => {
  const { disabled, status, store } = row
  const isDisabled = forceDisabled || disabled
  const statusLabel = forceDisabled ? 'Validando disponibilidade...' : status

  return (
    <div className={`${classes.storeCard} ${isDisabled ? classes.disabledStore : ''}`}>
      <FormControlLabel
        control={
          <Checkbox
            checked={selectedStoreIds.has(store._id) && !isDisabled}
            color='primary'
            disabled={hasLeftStep0 || isDisabled}
            onChange={() => toggleStore(store._id)}
          />
        }
        label={
          <Box textAlign='left'>
            <Typography variant='body2'>{store.name}</Typography>
            <Typography color='textSecondary' variant='caption'>{store.sellers} vendedores</Typography>
          </Box>
        }
      />
      <Chip label={statusLabel} size='small' color={isDisabled ? 'default' : 'primary'} variant={isDisabled ? 'default' : 'outlined'} />
    </div>
  )
}

export default StoreSelectionCard
